export default __webpack_public_path__ + "static/2025-img-articolo-marzo1-1e243a5e340379a23eda266bf7ce3b1d.jpg";